import React from 'react';
import ReactDOM from 'react-dom';
 
import App from './App';
// import reportWebVitals from './reportWebVitals';

import zhCN from '@jd/find-react/es/locale/zh_CN';
import { ConfigProvider } from '@jd/find-react';
console.log("index.js耗时：" + ((new Date()).valueOf() - window.startTime) + "毫秒");
 

ReactDOM.render(
  <ConfigProvider locale={zhCN}>
    <App />
   </ConfigProvider> ,
  document.getElementById('root')
);
 console.log("index.js2耗时：" + ((new Date()).valueOf() - window.startTime) + "毫秒");
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
